import type { ProductListItem } from "../../types/Product";
import { getPublicAffiliateLink } from "../../services/ProductsService";
import { getSafeAffiliateDestination } from "./GuestDealsUi.utils";

const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(",");

export function trapDialogFocus(event: KeyboardEvent, dialog: HTMLElement | null) {
  if (event.key !== "Tab" || !dialog) return;
  const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
  if (focusable.length === 0) {
    event.preventDefault();
    dialog.focus();
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

export async function openGuestRetailerDeal(
  product: ProductListItem,
  onOutbound: (url: string) => void
) {
	const productKey = product.productKey;
	if (!productKey) return false;

	// Create the tab during the click event so mobile browsers do not block it.
	// The browse payload never contains a retailer URL or raw product ID.
	const tab = window.open("about:blank", "_blank");
	if (tab) tab.opener = null;

	try {
		const resolvedUrl = await getPublicAffiliateLink(productKey);
		const destination = getSafeAffiliateDestination(resolvedUrl, "");
		if (!destination) throw new Error("Specific product response did not contain a safe destination");

		onOutbound(destination);
		if (tab && !tab.closed) tab.location.replace(destination);
		else window.location.assign(destination);
		return true;
	} catch {
		if (tab && !tab.closed) tab.close();
		return false;
	}
}
